<ng-container *ngIf="initialized">
  <form class="form" #myForm="ngForm" (ngSubmit)="onSave()" novalidate>
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Purchase CEUs</h5>
      </div>
      <div class="modal-body">
        <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
        <ng-container *ngIf="pricing">
          <div class="row">
            <div class="col">
              <h5>{{ pricing.certificationBody.name }}</h5>
              <h5>Price: {{ pricing.price | currency: pricing.currencyCode }}</h5>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group mt-3">
                <label for="inputAddress2">Card Number</label>
                <input type="text" required [(ngModel)]="cardNumber" name="cardNumber" class="form-control" />
                <div class="invalid-message">Card Number is Required</div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-5">
                  <label for="inputCity">Expiration Month</label>
                  <select class="form-control" [(ngModel)]="expMo" name="expMo" required>
                    <option value="1">01 - January</option>
                    <option value="2">02 - February</option>
                    <option value="3">03 - March</option>
                    <option value="4">04 - April</option>
                    <option value="5">05 - May</option>
                    <option value="6">06 - June</option>
                    <option value="7">07 - July</option>
                    <option value="8">08 - August</option>
                    <option value="9">09 - September</option>
                    <option value="10">10 - October</option>
                    <option value="11">11 - November</option>
                    <option value="12">12 - December</option>
                  </select>
                  <div class="invalid-message">Month is Required</div>
                </div>
                <div class="form-group col-md-5">
                  <label for="inputCity">Expiration Year</label>
                  <select class="form-control" [(ngModel)]="expYr" name="expYr" required>
                    <option value="2023">2023</option>
                    <option value="2024">2024</option>
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                    <option value="2027">2027</option>
                    <option value="2028">2028</option>
                    <option value="2029">2029</option>
                    <option value="2030">2030</option>
                    <option value="2031">2031</option>
                    <option value="2032">2032</option>
                    <option value="2033">2033</option>
                    <option value="2034">2034</option>
                  </select>
                  <div class="invalid-message">Year is Required</div>
                </div>
                <div class="form-group col-md-2">
                  <label for="cvv">CVV</label>
                  <input type="text" class="form-control" id="cvv" [(ngModel)]="cvv" name="cvv" />
                  <div class="invalid-message">CVV is Required</div>
                </div>
              </div>
              <button type="submit" class="btn btn-admin-primary btn-block" [promiseBtn]="submitComplete">Purchase</button>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="modal-footer">
        <div class="row">
          <div class="col-md-12">
            <button class="btn btn-sm btn-outline-dark" (click)="onCancel()" [promiseBtn]="submitComplete" type="button">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-container>
